<section class="container-transaction-item" *ngIf="transaction">
    <section class="circle">
        <mdk-icon-profile
            [imageURL]="(transaction?.transaction_type === 'CREDIT' ? 'plus.svg' : 'withdraw.svg') | staticServe"></mdk-icon-profile>
    </section>
    <section class="container-information">
        <section class="transaction-information">
            <span>{{ transaction.description | titlecase }}</span>
            <span>{{ transaction.transaction_date | date:'MMM dd, h:mm a' }}</span>
        </section>
        <span>{{ transaction.amount | currency }}</span>
    </section>
</section>